// @flow

import React, { type ElementProps } from "react";
import { ArrayFieldTemplateProps } from "@rjsf/core";
import { Button, Label, View, Text } from "@components";
import { LabelTemplate } from "@components/schema-form/templates";

import classNames from "classnames";

type Props = ElementProps<typeof ArrayFieldTemplateProps>;

const ArrayFieldTemplate = (props: Props) => {
  const uiOptions = props.uiSchema["ui:options"] || {};
  const handleAdd = e => {
    e.preventDefault();
    props.onAddClick(e);
  };
  const widget = props?.uiSchema["ui:widget"];
  const buttonTitle = (props.uiSchema["ui:options"] || {}).addButtonTitle;
  const labelclass = uiOptions.labelclass || "";

  return (
    <View
      gap={2}
      name="array-field-template"
      justifyContent="space-between"
      display={widget === "hidden" || props.hidden ? "none" : "flex"}
    >
      <View>
        <View direction="row" justifyContent="space-between">
          <View flex="1">{uiOptions.label && <LabelTemplate {...uiOptions} />}</View>
          <View flex="2" alignItems="end">
            {!props.disabled && (
              <Button
                materialIcon="add"
                className="p-2"
                label={buttonTitle}
                onClick={handleAdd}
                disabled={props.disabled}
              />
            )}
          </View>
        </View>
        {props.rawErrors && props.rawErrors.map && (
          <View>
            {props.rawErrors.map(e => (
              <Text text={e} key={e} className="text-danger mb-2" />
            ))}
          </View>
        )}
      </View>
      {props.items.map(item => {
        return (
          <View flex="1" position="relative" key={item.index} direction="row">
            {item.children}
            <Button
              className="secondary text-danger delete-item-button"
              onClick={item.onDropIndexClick(item.index)}
              materialIcon="delete_forever"
              disabled={props.disabled}
            />
          </View>
        );
      })}
    </View>
  );
};

export default ArrayFieldTemplate;
